import React, { Component } from "react";
import { Route, Link } from "react-router-dom";
import { Segment } from "semantic-ui-react";

import PageHeader from "../components/PageHeader";
import EventStats from "../components/event/EventStats";

import { eventRoutes } from "../utils/routes";
import request from "../utils/request";
import Error404 from "../pages/HttpError/Error404";

class EventRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      event: {}
    }
  }
  componentDidMount = async () => {
    let event = await this.getEvent(); // call getEvent() once component mounted
    this.setState({ event: event, isLoading: false });
  };
  componentDidUpdate = async (prevProps) => {
    if (this.props.match.params.id !== prevProps.match.params.id) { // call getEvent() again if id changed
      let event = await this.getEvent();
      this.setState({ event: event, isLoading: false });
    }
  };
  getEvent = () => { // fetch current event info
    this.setState({ isLoading: true });
    let eid = this.props.match.params.id;
    if (eid > 0 && eid !== "create") {
      return request.get(this, `api:/event/${this.props.match.params.id}`);
    }
    return false;
  };

  pauseWebSales = () => { // pause bump-ecommerce sales
    if (this.props.match.params.id === undefined) return false;

    return request
      .post(this, `api:/event/${this.props.match.params.id}/pause-ecomm-sales`)
      .then(resp => {
        this.setState(({ event }) => ({
          event: {
            ...event,
            web_sales_paused: resp.paused,
          }
        }));
        return true;
      })
      .then(done => {
        this.setState({ isLoading: !done });
      });
  };

  render() {
    const { match: currentRoute } = this.props;
    const { event, isLoading } = this.state;
    const eventId = currentRoute.params.id;

    let breadcrumbs = [
      {
        key: "events",
        content: "Events",
        link: true,
        as: Link,
        to: "/events"
      }
    ];

    if (eventId !== "create" && (event.error || event.exception)) {
      return (
        <Error404
          title="Invalid Event"
          content="We could not find the event you were looking for."
          breadcrumbs={breadcrumbs}
        />
      );
    }
    if (eventId > 0) {
      breadcrumbs.push({
        key: "eventId" + eventId,
        content: event.title,
        link: true,
        as: Link,
        to: `/events/${eventId}/summary`
      });
    }
    if (isLoading) return <Segment basic />;
    return (
      <Segment basic>
        {eventId > 0 && currentRoute.params.action !== "edit" && (
          <EventStats
            eventId={eventId}
            event={event}
            route={currentRoute}
            pause={this.pauseWebSales}
          />
        )}
        {eventRoutes.map((route, index) => (
          // Render more <Route>s with the same paths as
          // above, but different components this time.
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            render={props => {
              breadcrumbs.push({
                key: route.name,
                content: route.title,
                active: true
              });

              return (
                <div>
                  <PageHeader
                    title={event.title || route.title}
                    subtitle={event.title ? route.title : ""}
                    breadcrumbs={breadcrumbs}
                  />
                  <route.component
                    {...props}
                    eventId={currentRoute.params.id}
                    rsuEnabled={event?.rsu_enabled ?? 0}
                    cardSetId={event?.card_set_id ?? 0}
                    hasWinner={event?.haswinner}
                    gameId={event?.game_id}
                  />
                </div>
              );
            }}
          />
        ))}
      </Segment>
    );
  }
}

export default EventRouter;
